{
  "errors": {
    "notFound": {
      "title": "Page introuvable",
      "body": "La page que vous recherchez n'existe pas ou a été déplacée.",
      "ctaDashboard": "Aller au tableau de bord",
      "ctaBack": "Retour"
    },
    "serverError": {
      "title": "Une erreur est survenue",
      "body": "Une erreur inattendue est survenue. Notre équipe a été notifiée.",
      "ctaRetry": "Réessayer",
      "ctaDashboard": "Aller au tableau de bord"
    },
    "accessDenied": {
      "title": "Accès refusé",
      "body": "Vous n'avez pas la permission de voir cette page. Contactez un Super Admin si vous pensez qu'il s'agit d'une erreur.",
      "ctaDashboard": "Aller au tableau de bord",
      "ctaSupport": "Contacter le support"
    }
  },
  "common": {
    "skipToContent": "Aller au contenu principal",
    "loading": "Chargement…",
    "cancel": "Annuler"
  },
  "syncErrors": {
    "common": {
      "secondsAgo": "il y a {{value}} s",
      "minutesAgo": "il y a {{value}} min",
      "hoursAgo": "il y a {{value}} h",
      "daysAgo": "il y a {{value}} j",
      "loading": "Chargement…",
      "refresh": "Actualiser",
      "selectAll": "Tout sélectionner",
      "deselect": "Désélectionner",
      "cancel": "Annuler",
      "close": "Fermer",
      "processing": "Traitement…",
      "dash": "—"
    },
    "monitoring": {
      "title": "Supervision des erreurs de synchronisation",
      "rowsCount": "{{count}} lignes",
      "rowsCountLoading": "{{count}} lignes · chargement…",
      "retentionBanner": "Les erreurs de synchronisation de plus de 90 jours sont automatiquement purgées (politique de rétention TTL de la phase 5).",
      "filters": {
        "platform": "Plateforme",
        "merchantId": "ID marchand",
        "merchantIdPlaceholder": "ObjectId 24-hex",
        "errorType": "Type d'erreur",
        "errorTypePlaceholder": "error_type",
        "status": "Statut",
        "retryGte": "Reprises ≥",
        "dateFrom": "Date de début",
        "dateTo": "Date de fin"
      },
      "platformOptions": {
        "all": "Toutes les plateformes"
      },
      "statusOptions": {
        "all": "Tous les statuts",
        "open": "Ouvert",
        "retried": "Réessayé",
        "ignored": "Ignoré"
      },
      "bulk": {
        "selected": "Sélectionné",
        "syncErrorSuffix": "erreur de synchronisation",
        "retryCount": "Réessayer {{count}} lignes"
      },
      "table": {
        "timestamp": "Horodatage",
        "platform": "Plateforme",
        "merchant": "Marchand",
        "errorType": "Type d'erreur",
        "errorCode": "Code d'erreur",
        "retry": "Reprises",
        "status": "Statut",
        "actions": "Actions",
        "empty": "Aucune erreur de synchronisation ne correspond au filtre.",
        "rowSelectAria": "Sélectionner l'erreur de synchronisation {{id}}"
      },
      "actions": {
        "retry": "Réessayer",
        "ignore": "Ignorer"
      },
      "retryDialog": {
        "title": "Réessayer l'erreur de synchronisation ?",
        "description": "Re-mettre en file la synchronisation {{id}} ({{platform}}). Le worker de la phase 5 réessayera sur la file d'origine.",
        "confirm": "Réessayer"
      },
      "bulkRetryDialog": {
        "title": "Réessai en masse ?",
        "description": "Re-mettre en file {{count}} erreurs de synchronisation ? Chaque job sera réinjecté dans la file d'origine de la phase 5.",
        "confirm": "Réessayer {{count}} lignes"
      },
      "ignoreDialog": {
        "title": "Ignorer l'erreur de synchronisation ?",
        "body": "Saisissez le motif (10-500 caractères). Cette action est auditée.",
        "placeholder": "Exemple : La boutique est fermée, pas besoin de réessayer…",
        "confirm": "Confirmer l'ignorance"
      },
      "toast": {
        "loadFailedTitle": "Échec du chargement des erreurs de synchronisation",
        "loadFailedDesc": "Impossible de charger la liste des erreurs de synchronisation",
        "retryQueuedTitle": "Erreur de synchronisation re-mise en file",
        "retryQueuedDesc": "Synchronisation {{id}} re-mise en file (à {{time}}).",
        "retryFailedTitle": "Échec du réessai",
        "retryFailedDesc": "Échec du réessai",
        "bulkDoneTitle": "Réessai en masse terminé",
        "bulkDoneDesc": "Acceptés {{accepted}}/{{total}}.",
        "bulkDoneDescRejected": "Acceptés {{accepted}}/{{total}}, rejetés {{rejected}}.",
        "bulkFailedTitle": "Échec du réessai en masse",
        "bulkFailedDesc": "Échec du réessai en masse",
        "reasonShortTitle": "Motif trop court",
        "reasonShortDesc": "Veuillez saisir un motif d'au moins 10 caractères.",
        "ignoredTitle": "Marqué comme ignoré",
        "ignoredDesc": "Synchronisation {{id}} passée au statut \"ignored\".",
        "ignoreFailedTitle": "Échec de l'ignorance",
        "ignoreFailedDesc": "Échec de l'ignorance"
      }
    },
    "dlq": {
      "title": "File des messages morts (DLQ)",
      "totalJobs": "{{count}} jobs en échec",
      "totalJob": "{{count}} job en échec",
      "filters": {
        "queue": "File",
        "dateFrom": "Date de début",
        "dateTo": "Date de fin"
      },
      "queueOptions": {
        "all": "Toutes les files",
        "invoiceGeneration": "Génération de facture",
        "taxBundle": "Lot fiscal",
        "notificationEmail": "Notification email",
        "receiptGeneration": "Génération de reçu",
        "pendingReminder": "Rappel en attente"
      },
      "bulk": {
        "selected": "Sélectionné",
        "jobSuffix": "job",
        "retryAll": "Tout réessayer",
        "discardAll": "Tout rejeter"
      },
      "table": {
        "queue": "File",
        "jobId": "ID du job",
        "failedAt": "Échec à",
        "attempts": "Tentatives",
        "error": "Erreur",
        "actions": "Actions",
        "emptyFiltered": "Aucun job en échec ne correspond au filtre.",
        "empty": "Aucun job en échec dans la DLQ.",
        "rowSelectAria": "Sélectionner le job {{id}}"
      },
      "actions": {
        "view": "Voir",
        "retry": "Réessayer",
        "discard": "Rejeter"
      },
      "retryDialog": {
        "title": "Réessayer le job ?",
        "description": "Re-mettre en file le job {{id}} sur la file {{queue}} ?",
        "confirm": "Réessayer"
      },
      "discardDialog": {
        "title": "Rejeter le job de la DLQ",
        "body": "Le job <strong>{{id}}</strong> ({{queue}}) sera supprimé définitivement de la DLQ. Le motif sera enregistré dans le journal d'audit.",
        "reasonLabel": "Motif (1-500 caractères)",
        "reasonPlaceholder": "Ex : Job de test depuis la préprod, sans rapport avec les données réelles",
        "errorTooShort": "Saisissez un motif (1-500 caractères).",
        "errorTooLong": "Le motif doit faire au maximum 500 caractères.",
        "confirm": "Rejeter"
      },
      "bulkRetryDialog": {
        "title": "Réessai en masse ?",
        "description": "Re-mettre en file {{count}} jobs ? Chaque job utilise sa propre Idempotency-Key et est audité.",
        "confirm": "Réessayer {{count}} jobs"
      },
      "bulkDiscardDialog": {
        "title": "Rejeter {{count}} jobs de la DLQ",
        "body": "{{count}} jobs seront supprimés définitivement. Le motif sera utilisé pour chaque entrée du journal d'audit.",
        "reasonLabel": "Motif (1-500 caractères)",
        "reasonPlaceholder": "Ex : Nettoyage des données de test après un déploiement préprod",
        "errorTooShort": "Saisissez un motif (1-500 caractères).",
        "errorTooLong": "Le motif doit faire au maximum 500 caractères.",
        "confirm": "Rejeter {{count}} jobs"
      },
      "payloadDialog": {
        "title": "Payload — {{id}}",
        "queue": "File :",
        "attempts": "Tentatives :",
        "failedAt": "Échec à :",
        "error": "Erreur :",
        "payloadJson": "Payload JSON"
      },
      "toast": {
        "endpointNotReadyTitle": "Endpoint DLQ non prêt",
        "endpointNotReadyDesc": "Backend Task 24 (enregistrement BullMQ) non déployé — affichage vide.",
        "loadFailedTitle": "Échec du chargement de la DLQ",
        "networkErrorTitle": "Erreur réseau — vérifiez votre connexion",
        "alreadyRetriedTitle": "Job déjà réessayé",
        "alreadyRetriedDesc": "Un autre admin vient de le traiter — la liste va se rafraîchir.",
        "retryFailedTitle": "Échec du réessai",
        "retryQueuedTitle": "Job re-mis en file",
        "retryQueuedDesc": "Le job {{id}} a été re-mis en file sur {{queue}}.",
        "discardFailedTitle": "Échec du rejet",
        "discardedTitle": "Job rejeté",
        "discardedDesc": "Le job {{id}} a été supprimé de la DLQ et enregistré dans le journal d'audit.",
        "bulkRetryDoneTitle": "Réessai en masse terminé",
        "bulkRetryDoneDesc": "Réussis {{success}}/{{total}}.",
        "bulkRetryDoneDescFailed": "Réussis {{success}}/{{total}}, échoués {{failed}}.",
        "bulkDiscardDoneTitle": "Rejet en masse terminé",
        "bulkDiscardDoneDesc": "Rejetés {{success}}/{{total}}.",
        "bulkDiscardDoneDescFailed": "Rejetés {{success}}/{{total}}, échoués {{failed}}."
      }
    },
    "dlqDetail": {
      "title": "DLQ des erreurs de synchronisation",
      "rowsCount": "{{count}} lignes (page {{page}})",
      "retentionBanner": "Les erreurs de synchronisation sont automatiquement purgées après 90 jours (hérite de la politique de rétention de la phase 5).",
      "exportCsv": "Exporter en CSV",
      "filters": {
        "storeId": "ID de boutique",
        "storeIdPlaceholder": "ObjectId 24-hex",
        "platform": "Plateforme",
        "errorType": "Type d'erreur",
        "errorTypePlaceholder": "error_class",
        "retried": "Réessayé",
        "dateFrom": "Date de début",
        "dateTo": "Date de fin"
      },
      "platformOptions": {
        "all": "Toutes les plateformes"
      },
      "retriedOptions": {
        "all": "Tous",
        "no": "Non réessayé",
        "yes": "Réessayé"
      },
      "statusOptions": {
        "pending": "En attente",
        "retrying": "Réessai en cours",
        "resolved": "Résolu",
        "permanentlyFailed": "Échec définitif"
      },
      "bulk": {
        "selected": "Sélectionné",
        "syncErrorSuffix": "erreur de synchronisation",
        "retryCount": "Réessayer {{count}} lignes"
      },
      "table": {
        "store": "Boutique",
        "platform": "Plateforme",
        "errorType": "Type d'erreur",
        "error": "Erreur",
        "retry": "Reprises",
        "status": "Statut",
        "timestamp": "Horodatage",
        "actions": "Actions",
        "empty": "Aucune erreur de synchronisation ne correspond au filtre.",
        "rowSelectAria": "Sélectionner l'erreur de synchronisation {{id}}"
      },
      "actions": {
        "retry": "Réessayer"
      },
      "pagination": {
        "info": "Page {{page}} · {{count}} lignes",
        "prev": "Précédent",
        "next": "Suivant"
      },
      "retryDialog": {
        "title": "Réessayer l'erreur de synchronisation ?",
        "description": "Re-mettre en file le job de synchronisation pour la boutique {{store}} ? Le worker de la phase 5 réessayera sur la file d'origine.",
        "confirm": "Réessayer"
      },
      "bulkRetryDialog": {
        "title": "Réessai en masse ?",
        "description": "Re-mettre en file {{count}} erreurs de synchronisation ? Chaque job sera réinjecté dans la file d'origine de la phase 5.",
        "confirm": "Réessayer {{count}} lignes"
      },
      "toast": {
        "loadFailedTitle": "Échec du chargement des erreurs de synchronisation",
        "loadFailedDesc": "Impossible de charger la liste des erreurs de synchronisation",
        "retryQueuedTitle": "Erreur de synchronisation re-mise en file",
        "retryQueuedDesc": "Job {{id}} re-mis en file ({{count}} jobs en file).",
        "noLongerInDlqTitle": "Erreur de synchronisation absente de la DLQ",
        "noLongerInDlqDesc": "Un autre admin l'a peut-être déjà réessayée — la liste va se rafraîchir.",
        "retryFailedTitle": "Échec du réessai",
        "retryFailedDesc": "Échec du réessai",
        "bulkDoneTitle": "Réessai en masse terminé",
        "bulkDoneDesc": "Réussis {{success}}/{{total}}.",
        "bulkDoneDescFailed": "Réussis {{success}}/{{total}}, échoués {{failed}}.",
        "bulkFailedTitle": "Échec du réessai en masse",
        "bulkFailedDesc": "Échec du réessai en masse",
        "exportDoneTitle": "CSV exporté",
        "exportDoneDesc": "{{count}} lignes téléchargées.",
        "exportFailedTitle": "Échec de l'export",
        "exportFailedDesc": "Échec de l'export"
      }
    },
    "reports": {
      "header": {
        "title": "Rapports d'erreurs de synchronisation",
        "subtitle": "Rapports d'erreurs de synchronisation par source / type d'entité / statut. Réessai manuel par ligne ; opérations DLQ sur la page Monitoring.",
        "loading": "Chargement…",
        "refresh": "Actualiser"
      },
      "retention": {
        "default": "Les rapports d'erreurs de synchronisation sont supprimés automatiquement après 90 jours (hérite de la politique de rétention de la Phase 5).",
        "withPolicy": "Les rapports d'erreurs de synchronisation sont supprimés automatiquement après {{policy}}."
      },
      "filter": {
        "source": "Source",
        "entity": "Entité",
        "resolved": "Statut de résolution",
        "from": "Du",
        "to": "Au",
        "search": "Rechercher",
        "searchPlaceholder": "error_code ou contenu",
        "clear": "Effacer les filtres"
      },
      "sourceOption": {
        "all": "Toutes les sources"
      },
      "entityOption": {
        "all": "Toutes les entités",
        "order": "Commandes",
        "product": "Produits",
        "inventory": "Stock",
        "customer": "Clients"
      },
      "resolvedOption": {
        "all": "Tous",
        "no": "Non traité",
        "yes": "Traité"
      },
      "column": {
        "timestamp": "Horodatage",
        "source": "Source",
        "entity": "Entité",
        "store": "Boutique",
        "merchant": "Marchand",
        "errorCode": "Code d'erreur",
        "message": "Message",
        "retry": "Réessai",
        "status": "Statut",
        "action": "Actions"
      },
      "status": {
        "open": "Nouveau",
        "retried": "Réessayé",
        "ignored": "Ignoré",
        "resolved": "Résolu"
      },
      "empty": "Aucune erreur de synchronisation ne correspond au filtre.",
      "retry": "Réessayer",
      "pagination": {
        "summary": "Page {{page}} · {{count}} lignes",
        "prev": "Précédent",
        "next": "Suivant"
      },
      "confirm": {
        "title": "Réessayer l'erreur de synchronisation ?",
        "description": "Remettre en file le job pour {{target}} ({{errorCode}}) ? Le worker Phase 5 réessaiera sur la queue d'origine.",
        "label": "Réessayer"
      },
      "relative": {
        "secondsAgo": "il y a {{count}}s",
        "minutesAgo": "il y a {{count}} min",
        "hoursAgo": "il y a {{count}} h",
        "daysAgo": "il y a {{count}} j"
      },
      "toast": {
        "loadFailedTitle": "Impossible de charger les rapports d'erreurs de synchronisation",
        "loadFailedFallback": "Impossible de charger les rapports d'erreurs de synchronisation",
        "retrySuccessTitle": "Erreur de synchronisation re-mise en file",
        "retrySuccessDescription": "Job {{jobId}} remis en file ({{count}} job mis en file).",
        "notInDlqTitle": "Erreur de synchronisation absente de la DLQ",
        "notInDlqDescription": "Un autre admin l'a peut-être déjà réessayée — la liste va se rafraîchir.",
        "retryFailedTitle": "Échec du réessai",
        "retryFailedFallback": "Échec du réessai"
      }
    }
  },
  "payouts": {
    "queue": {
      "page": {
        "title": "Versements fournisseurs",
        "subtitle": "Examiner et rapprocher les demandes de paiement des vendeurs — une seule approbation par ligne."
      },
      "tab": {
        "all": "Tous",
        "pending": "En attente",
        "processing": "En cours",
        "completed": "Terminé",
        "failed": "Échec"
      },
      "summary": {
        "totalPending": "Total en attente",
        "approvedThisMonth": "Approuvé ce mois-ci"
      },
      "chart": {
        "title": "Répartition par statut (lignes visibles)",
        "countSuffix": "paiements",
        "noData": "Aucune donnée."
      },
      "filter": {
        "ariaLabel": "Filtrer le statut des paiements",
        "preKycChip": "Pré-KYC en attente",
        "loading": "Chargement…",
        "results": "{{count}} résultats"
      },
      "column": {
        "vendor": "Vendeur",
        "net": "Net",
        "gateway": "Gateway",
        "status": "Statut",
        "createdAt": "Créé",
        "action": "Actions"
      },
      "list": {
        "loading": "Chargement des paiements…",
        "errorTitle": "Impossible de charger la liste des paiements.",
        "retry": "Réessayer",
        "emptyPreKyc": "Aucun vendeur Pré-KYC dans ce statut.",
        "emptyDefault": "Aucun paiement correspondant."
      },
      "row": {
        "preKycTitle": "Pré-KYC en attente — paiement bloqué",
        "preKycBadge": "Pré-KYC ({{kycStatus}})",
        "vendorPrefix": "vendeur : {{vendorId}}",
        "failedNoRetry": "Pas de réessai automatique. Les gains ont été remis sur Disponible.",
        "failedReason": "Raison : {{reason}}",
        "approve": "Approuver",
        "reject": "Rejeter",
        "markTransferred": "Marquer comme transféré",
        "closed": "Clôturé — aucune action requise"
      },
      "relative": {
        "justNow": "à l'instant",
        "minutes": "il y a {{count}} min",
        "hours": "il y a {{count}} h",
        "days": "il y a {{count}} j"
      }
    },
    "approve": {
      "ariaLabel": "Approuver le paiement — {{vendor}}",
      "title": "Approuver le paiement — {{vendor}}",
      "bodyLead": "Le paiement passera de",
      "bodyTo": "à",
      "bodyTail": ". Le KYC vendeur sera re-vérifié côté serveur.",
      "bodyFrom": "En attente",
      "bodyDest": "En cours",
      "amountLabel": "Montant (net)",
      "gatewayLabel": "Gateway",
      "cancel": "Annuler",
      "confirm": "Approuver",
      "submitting": "Approbation…",
      "toast": {
        "successTitle": "Paiement approuvé",
        "successDescription": "{{vendor}} passe à En cours.",
        "kycBlockedTitle": "Le vendeur n'a pas terminé le KYC",
        "kycBlockedFallback": "Paiement bloqué — le vendeur doit d'abord finaliser le KYC.",
        "stateChangedTitle": "Le statut du paiement a changé",
        "stateChangedFallback": "Le paiement n'est plus En attente — la liste va se recharger.",
        "approveFailedTitle": "Impossible d'approuver le paiement",
        "networkErrorTitle": "Erreur réseau",
        "networkErrorFallback": "Vérifiez votre connexion et réessayez."
      }
    },
    "reject": {
      "ariaLabel": "Rejeter le paiement — {{vendor}}",
      "title": "Rejeter le paiement — {{vendor}}",
      "bodyLead": "Les gains seront",
      "bodyBold": "réintégrés",
      "bodyTail": "au portefeuille Disponible du vendeur (pas de réessai automatique, le vendeur doit créer une nouvelle demande).",
      "reasonLabel": "Raison du rejet",
      "reasonRequired": "*",
      "reasonPlaceholder": "Ex. : le nom du compte bancaire ne correspond pas au document KYC.",
      "reasonHelp": "Visible par le vendeur. 10-500 caractères.",
      "errorMin": "Raison obligatoire (10 caractères minimum).",
      "errorMax": "Raison trop longue (500 caractères maximum).",
      "cancel": "Annuler",
      "confirm": "Rejeter",
      "submitting": "Rejet…",
      "toast": {
        "successTitle": "Paiement rejeté",
        "successDescription": "Les gains de {{vendor}} ont été remis sur le portefeuille Disponible.",
        "stateChangedTitle": "Le statut du paiement a changé",
        "stateChangedFallback": "Le paiement n'est plus En attente — la liste va se recharger.",
        "rejectFailedTitle": "Impossible de rejeter le paiement",
        "networkErrorTitle": "Erreur réseau",
        "networkErrorFallback": "Vérifiez votre connexion et réessayez."
      }
    }
  },
  "orderCancel": {
    "modal": {
      "title": "Annuler la commande",
      "descWithNumberLead": "Commande",
      "descWithNumberMiddle": "— valeur",
      "descWithNumberTail": ". L'annulation est une double décision : remboursement marchand (1) et compensation vendeur (2) sont indépendants.",
      "descDefault": "L'annulation est une double décision : remboursement marchand (1) et compensation vendeur (2) sont indépendants."
    },
    "mode": {
      "legend": "Mode d'annulation",
      "softTitle": "Annulation douce",
      "softHelp": "Commande pas encore en production, vendeur non facturé — annuler maintenant",
      "forceTitle": "Annulation forcée",
      "forceHelp": "Commande en/post-production — envisager une compensation vendeur"
    },
    "refund": {
      "legend": "(1) Remboursement marchand",
      "full": "Remboursement total ({{value}})",
      "partial": "Remboursement partiel",
      "none": "Aucun remboursement",
      "partialLabel": "Montant remboursé (cents — entiers USD)",
      "partialPlaceholder": "1..{{max}}",
      "partialError": "Doit être supérieur à 0 et ne pas dépasser {{max}}"
    },
    "compensation": {
      "legend": "(2) Compensation vendeur",
      "enableTitle": "Indemniser le vendeur depuis le budget plateforme",
      "enableHelp": "La compensation est payée par la plateforme, sans déduction côté marchand.",
      "noVendor": " — cette commande n'a pas de vendeur assigné, compensation indisponible.",
      "amountLabel": "Montant de compensation (cents)",
      "amountPlaceholder": "ex. 5000 (= 50,00 $)",
      "reasonLabel": "Motif de la compensation (1..{{max}} caractères)",
      "reasonPlaceholder": "ex. vendeur a terminé l'impression, faute non imputable au vendeur"
    },
    "reason": {
      "legend": "Raison de l'annulation",
      "codeLabel": "Code de raison",
      "detailLabel": "Détail (>= {{min}} caractères)",
      "remainingChars": "{{count}} caractères supplémentaires requis",
      "valid": "Valide",
      "codes": {
        "CHANGED_MIND": "Client a changé d'avis",
        "WRONG_ADDRESS": "Adresse erronée",
        "WRONG_PRODUCT": "Produit erroné",
        "WRONG_ARTWORK": "Visuel erroné",
        "DUPLICATE_ORDER": "Commande en double",
        "CUSTOMER_REQUEST": "Demande client",
        "OTHER": "Autre (saisir la raison)",
        "VENDOR_FAILURE": "Défaillance vendeur",
        "FRAUD_SUSPECTED": "Fraude suspectée",
        "SYSTEM_ERROR": "Erreur système",
        "POLICY_VIOLATION": "Violation de politique"
      }
    },
    "dualApproval": {
      "title": "Double approbation requise (Dual approval)",
      "reasonRefund": "Total remboursé marchand ({{refund}}) dépasse le seuil {{threshold}}",
      "reasonForce": "Annulation forcée d'une commande ({{value}}) dépasse le seuil {{threshold}}",
      "footnote": "La demande sera mise en attente et un second admin devra l'approuver."
    },
    "errors": {
      "network": "Erreur réseau - vérifiez la connexion"
    },
    "cta": {
      "close": "Fermer",
      "submitting": "Traitement…",
      "submitApproval": "Soumettre pour approbation",
      "submitForce": "Annulation forcée",
      "submitDefault": "Annuler la commande"
    }
  },
  "creditEditor": {
    "titleCreate": "Accorder un nouveau crédit",
    "titleEdit": "Modifier le crédit",
    "field": {
      "email": {
        "label": "Email marchand"
      },
      "description": {
        "label": "Description (facultatif)",
        "placeholder": "Exemple : ligne de crédit promotionnelle Q2"
      },
      "limit": {
        "label": "Limite (USD)",
        "editHint": "(augmentation seulement — min ${{min}})",
        "required": "La limite est obligatoire",
        "minError": "Minimum ${{min}}",
        "centsHint": "= {{cents}} cents"
      },
      "period": {
        "label": "Période (jours)",
        "modePreset": "Préréglage",
        "modeCustom": "Personnalisé",
        "dayUnit": "{{count}} jours",
        "minError": "Minimum 1 jour",
        "maxError": "Maximum 3650 jours"
      },
      "startDate": {
        "label": "Date de début",
        "immutableHint": "(non modifiable)",
        "required": "La date de début est obligatoire",
        "invalid": "La date de début est invalide"
      }
    },
    "options": {
      "legend": "Options",
      "notify": "Notifier le marchand quand le crédit est accordé (notify)",
      "expiryReminder": "Activer le rappel d'expiration 7 + 1 jours",
      "autoLock": "Verrouiller la création de commandes en cas d'arriéré (auto-lock overdue)",
      "autoReset": "Restauration automatique quand le solde est nul + expiré (auto-reset)",
      "remindAt": "Rappel quand la dépense atteint le seuil (remind-at-amount)",
      "remindAtThreshold": "Seuil (USD)",
      "remindAtMinError": "Minimum 1 $"
    },
    "cta": {
      "cancel": "Annuler",
      "create": "Accorder le crédit",
      "save": "Enregistrer",
      "saving": "Enregistrement…"
    },
    "toast": {
      "invalidDataTitle": "Données invalides",
      "invalidDataFallback": "Veuillez vérifier le formulaire",
      "createSuccess": "Crédit accordé",
      "createFail": "Impossible d'accorder le crédit",
      "unknownError": "Erreur inconnue",
      "overdueTitle": "Impossible d'accorder le crédit",
      "overdueDesc": "Le marchand est en retard — impossible d'accorder un nouveau crédit",
      "missingCreditId": "creditId manquant (mode édition)",
      "noChanges": "Aucune modification à enregistrer",
      "editSuccess": "Crédit mis à jour",
      "editFail": "Impossible de mettre à jour le crédit"
    }
  },
  "systemHealth": {
    "title": "Santé du système",
    "superAdminAria": "Super administrateur uniquement",
    "refreshing": "Actualisation…",
    "subtitle": "Tableau de bord de surveillance en temps réel — actualisation automatique toutes les 10 secondes. Affiche les ressources système, les performances API, l'état des services, les alertes et les sauvegardes récentes.",
    "metric": {
      "windowOption": {
        "10m": "10 min",
        "1h": "1 heure",
        "6h": "6 heures"
      }
    },
    "section": {
      "resources": "Ressources système",
      "infra": "Infrastructure",
      "apiPerf": "Performance API",
      "services": "État des services",
      "alerts": "Règles d'alerte",
      "backup": "Sauvegarde"
    },
    "alertRule": {
      "label": {
        "cpuHigh": "CPU élevé",
        "memoryHigh": "Mémoire élevée",
        "diskHigh": "Disque élevé",
        "apiP95High": "API p95 lente",
        "redisMemoryHigh": "Mémoire Redis élevée",
        "dbConnectionsHigh": "Connexions DB élevées"
      },
      "saveCta": "Enregistrer les seuils",
      "saving": "Enregistrement…",
      "toast": {
        "saveSuccessTitle": "Seuils d'alerte enregistrés",
        "saveSuccessDesc": "Appliqués à la prochaine évaluation du collecteur.",
        "saveFailTitle": "Impossible d'enregistrer les seuils"
      },
      "footnote": "Seuils par défaut : 80/95/100. Les modifications sont enregistrées dans system_settings.security.anomaly_rules et appliquées au prochain passage du collecteur.",
      "activeSincePrefix": "Depuis {{time}}"
    },
    "backup": {
      "recentTitle": "Sauvegardes récentes (7 jours)",
      "recentDesc": "Actualisation automatique toutes les 10 secondes, avec les autres métriques.",
      "column": {
        "jobId": "ID du job",
        "scope": "Périmètre",
        "start": "Démarrée",
        "end": "Terminée",
        "status": "Statut",
        "size": "Taille",
        "download": "Téléchargement"
      },
      "empty": {
        "loading": "Chargement de l'historique des sauvegardes…",
        "none": "Aucune sauvegarde sur les 7 derniers jours."
      },
      "status": {
        "succeeded": "Réussie",
        "running": "En cours",
        "failed": "Échouée"
      },
      "downloadLink": "Télécharger",
      "triggerCta": "Déclencher une sauvegarde",
      "unavailableHint": "La sauvegarde automatique n'est pas encore disponible (worker non implémenté).",
      "dialog": {
        "title": "Déclencher une sauvegarde manuelle",
        "scopeLabel": "Périmètre",
        "reasonLabel": "Raison",
        "reasonPlaceholder": "Exemple : snapshot pré-release phase 8.3",
        "reasonHint": "Minimum 10 caractères — pour le journal d'audit.",
        "cancel": "Annuler",
        "enqueueCta": "Mettre en file",
        "enqueuing": "Mise en file…",
        "scopeOption": {
          "db": "Base de données",
          "files": "Fichiers",
          "full": "Complet (DB + fichiers)"
        }
      },
      "toast": {
        "enqueueSuccessTitle": "Sauvegarde mise en file",
        "enqueueSuccessDescPrefix": "Job {{jobId}}",
        "enqueueFailTitle": "Impossible de mettre la sauvegarde en file",
        "reasonRequiredTitle": "Raison requise",
        "reasonRequiredDesc": "Minimum 10 caractères — pour le journal d'audit."
      }
    },
    "service": {
      "restartTitlePrefix": "Redémarrer {{svc}}",
      "restartDesc": "Le redémarrage API sera câblé dans la surface ops de la Phase 9. Pour l'instant, la demande est seulement enregistrée."
    }
  },
  "orderWarnings": {
    "title": "Alertes commandes",
    "subtitle": "Alertes par marchand/vendeur (Retard production / Retard livraison / Problème qualité). Ouvrez la commande pour la traiter.",
    "refreshCta": "Actualiser",
    "refreshing": "Chargement…",
    "filter": {
      "severityLabel": "Sévérité",
      "ageLabel": "Ancienneté",
      "statusLabel": "Statut",
      "categoryLabel": "Catégorie",
      "vendorIdLabel": "ID vendeur",
      "merchantIdLabel": "ID marchand",
      "fromLabel": "Du",
      "toLabel": "Au",
      "searchLabel": "Rechercher",
      "objectIdPlaceholder": "ObjectId 24-hex",
      "searchPlaceholder": "N° de commande ou contenu",
      "clearCta": "Effacer les filtres"
    },
    "severityOption": {
      "all": "Toutes les sévérités",
      "high": "Élevée",
      "medium": "Moyenne",
      "low": "Faible"
    },
    "severityShort": {
      "high": "Élev.",
      "medium": "Moy.",
      "low": "Faib."
    },
    "ageOption": {
      "all": "Toutes les anciennetés",
      "lt24h": "< 24 heures",
      "1to3d": "1 - 3 jours",
      "gt3d": "> 3 jours"
    },
    "statusOption": {
      "all": "Tous les statuts",
      "open": "Nouveau",
      "acknowledged": "Pris en compte",
      "resolved": "Résolu"
    },
    "categoryOption": {
      "all": "Toutes les catégories",
      "lateProduction": "Retard production",
      "lateShipping": "Retard livraison",
      "qualityIssue": "Problème qualité"
    },
    "column": {
      "order": "N° commande",
      "category": "Catégorie",
      "merchant": "Marchand",
      "vendor": "Vendeur",
      "severity": "Sévérité",
      "age": "Ancienneté",
      "status": "Statut",
      "content": "Contenu",
      "actions": "Actions"
    },
    "empty": "Aucune alerte ne correspond aux filtres.",
    "drillCta": "Ouvrir la commande",
    "pageInfo": "Page {{page}} · {{count}} lignes",
    "pagePrev": "Précédent",
    "pageNext": "Suivant",
    "ageUnit": {
      "hours": "{{count}} heures",
      "daysShort": "{{days}}j {{hours}}h",
      "daysFull": "{{count}} jours"
    },
    "toast": {
      "loadFailTitle": "Impossible de charger les alertes",
      "loadFailFallback": "Impossible de charger les alertes"
    }
  },
  "gateway": {
    "settings": {
      "toast": {
        "savedTitle": "Configuration de la passerelle enregistrée",
        "saveFailedTitle": "Impossible d'enregistrer la configuration",
        "webhookRegeneratedTitle": "Secret du webhook régénéré",
        "webhookRegeneratedDesc": "Mettez à jour le nouveau secret dans le tableau de bord de la passerelle pour que les webhooks continuent à être vérifiés.",
        "webhookRegenerateFailedTitle": "Impossible de régénérer le webhook",
        "webhookCopiedTitle": "URL du webhook copiée"
      },
      "loading": "Chargement de la configuration {{gateway}}…",
      "loadFailedPrefix": "Chargement impossible :",
      "tierLockedTier1": "Passerelle de niveau 1 — hot-swap non pris en charge.",
      "tierLockedTier2": "Passerelle de niveau 2 — hot-swap non pris en charge.",
      "savingShort": "Enregistrement…",
      "pauseDialog": {
        "titlePause": "Mettre en pause la passerelle {{gateway}} ?",
        "titleResume": "Réactiver la passerelle {{gateway}} ?",
        "descPause": "La file BullMQ sera mise en pause et le portail marchand affichera le badge « Maintenance ». Une raison (≥{{min}} caractères) est requise pour l'audit log.",
        "descResume": "La file BullMQ reprendra automatiquement. Notes facultatives.",
        "reasonLabelPause": "Raison (≥{{min}} caractères)",
        "reasonLabelResume": "Notes (facultatif)",
        "reasonPlaceholderPause": "ex. Suspicion de pic de fraude — investigation en cours",
        "reasonPlaceholderResume": "ex. Le health check est stable depuis 5 minutes",
        "reasonTooShort": "La raison doit comporter au moins {{min}} caractères (actuellement {{count}}).",
        "cancel": "Annuler",
        "processing": "Traitement…",
        "confirmPause": "Mettre en pause",
        "confirmResume": "Réactiver"
      },
      "pauseBanner": "File en pause — le portail marchand affiche le badge « Maintenance ». Aucun basculement automatique vers une autre passerelle.",
      "card": {
        "auditNotice": "Chaque révélation est enregistrée dans l'audit log et masquée automatiquement après 30 s.",
        "statusHeading": "Statut"
      },
      "toastP8": {
        "pausedTitle": "{{gateway}} mise en pause",
        "resumedTitle": "{{gateway}} réactivée",
        "networkError": "Erreur réseau — vérifiez votre connexion.",
        "alreadyPausedTitle": "Passerelle déjà en pause",
        "pauseFailedTitle": "Impossible de mettre en pause",
        "notPausedTitle": "La passerelle n'est pas en pause",
        "resumeFailedTitle": "Impossible de réactiver"
      },
      "panel": {
        "statusFilterLabel": "Statut",
        "statusFilterAll": "Tous",
        "loadingList": "Chargement de la liste des passerelles…",
        "loadFailedPrefix": "Chargement impossible :",
        "loadFailedUnknown": "erreur inconnue",
        "empty": "Aucune passerelle de paiement dans ce statut."
      }
    }
  },
  "emailTemplate": {
    "variables": {
      "errorKeyEmpty": "La clé de variable ne peut pas être vide.",
      "errorKeyPattern": "La clé ne peut contenir que des minuscules, chiffres et underscores (a-z, 0-9, _).",
      "errorKeyDuplicate": "La clé « {{key}} » existe déjà.",
      "errorDescriptionEmpty": "La description de la variable ne peut pas être vide.",
      "hint": "Les noms de variables sont rendus sous la forme <code>{{syntax}}</code> à l'envoi de l'e-mail.",
      "empty": "Aucune variable — ajoutez-en une ci-dessous.",
      "insert": "Insérer",
      "remove": "Supprimer",
      "defaultLabel": "Par défaut",
      "addLegend": "Ajouter une nouvelle variable",
      "addButton": "Ajouter la variable"
    },
    "editor": {
      "validationNameShort": "Le nom du modèle doit comporter au moins 2 caractères.",
      "validationSubjectEnShort": "Le sujet (EN) doit comporter au moins 2 caractères.",
      "validationBodyEnShort": "Le corps (EN) doit comporter au moins 10 caractères.",
      "createdToast": "Modèle créé",
      "savedToast": "Modèle enregistré",
      "saveFailedToast": "Échec de l'enregistrement",
      "previewWarnUnsavedTitle": "Enregistrez le modèle avant l'aperçu",
      "previewPopupBlockedTitle": "Le navigateur a bloqué la nouvelle fenêtre",
      "previewPopupBlockedDesc": "Autorisez les pop-ups pour le domaine admin et réessayez.",
      "previewFailedTitle": "Échec de l'aperçu",
      "translateWarnUnsavedTitle": "Enregistrez le modèle avant la traduction",
      "translateWarnSameLangTitle": "Choisissez une langue cible autre que EN",
      "translateDoneTitle": "Traduit en {{target}}",
      "translateDoneDesc": "{{count}} champs — traducteur {{translator}}",
      "translateFailedTitle": "Échec de la traduction",
      "headerTitleNew": "Créer un modèle d'e-mail",
      "headerTitleEdit": "Modifier le modèle d'e-mail",
      "headerSubtitle": "TipTap WYSIWYG · i18n EN / VI / FR · variables rendues comme <code>{{syntax}}</code> · Google Translate bulk EN→VI.",
      "backLabel": "Retour aux modèles d'e-mails",
      "previewing": "Rendu en cours…",
      "translating": "Traduction…",
      "translateButton": "Traduire EN → VI",
      "savingShort": "Enregistrement…",
      "createShort": "Créer",
      "saveShort": "Enregistrer",
      "loading": "Chargement…",
      "nameLabel": "Nom du modèle",
      "categoryLabel": "Catégorie",
      "bodyPlaceholder": "Rédigez le contenu de l'e-mail…",
      "previewTextPlaceholder": "Affiché dans l'aperçu de la boîte de réception",
      "previewTextHelp": "Affiché à côté du sujet dans la boîte de réception (Gmail, Outlook)."
    }
  },
  "wallet": {
    "adjustment": {
      "reasonOption": {
        "penalty": "Pénalité",
        "qualityIssue": "Problème de qualité",
        "return": "Retour",
        "bonus": "Bonus",
        "correction": "Correction de solde",
        "other": "Autre"
      },
      "title": "Ajuster le solde du portefeuille vendeur",
      "descriptionWithName": "Créer un ajustement manuel pour le portefeuille du vendeur <strong>{{vendor}}</strong>. Chaque ajustement est audité ; les montants > 10 000 $ USD nécessitent l'approbation d'un second administrateur.",
      "descriptionGeneric": "Créer un ajustement manuel pour le portefeuille du vendeur. Chaque ajustement est audité ; les montants > 10 000 $ USD nécessitent l'approbation d'un second administrateur.",
      "typeLegend": "Type d'ajustement",
      "typeCredit": "+ Crédit (Ajouter au portefeuille)",
      "typeDebit": "− Débit (Retirer du portefeuille)",
      "amountLabel": "Montant (USD)",
      "amountInvalid": "Montant invalide — saisissez en USD avec au plus 2 décimales, supérieur à 0.",
      "reasonGroupLabel": "Groupe de raison",
      "reasonDetailLabel": "Raison détaillée",
      "reasonDetailMinHint": "(minimum {{min}} caractères)",
      "reasonDetailPlaceholder": "Décrivez la raison en détail — enregistrée dans l'audit log",
      "reasonDetailRemaining": "Encore {{count}} caractère(s) requis",
      "linkedOrderLabel": "ID de commande liée",
      "linkedOrderOptionalHint": "(facultatif)",
      "linkedOrderPlaceholder": "ObjectId de commande — laissez vide si non rattaché à une commande",
      "linkedOrderInvalid": "L'ID de commande doit être une chaîne hex de 24 caractères.",
      "previewHeading": "Aperçu du solde",
      "negativeWarning": "Le solde après ajustement serait négatif — interdit. Réduisez le montant ou passez en crédit.",
      "dualApprovalLabel": "Approbation double requise :",
      "dualApprovalBodyPre": "Ce montant dépasse le seuil de 10 000 $ USD. La requête restera en",
      "dualApprovalBodyEm": "En attente d'approbation par un pair",
      "dualApprovalBodyPost": "jusqu'à ce qu'un autre administrateur l'approuve depuis la file.",
      "auditNotice": "Chaque ajustement de portefeuille est enregistré dans <code>audit_logs</code> avec l'identité de l'opérateur, son IP, l'horodatage et la raison — pour l'auditabilité et la réversibilité.",
      "cancel": "Annuler",
      "submitting": "Envoi…",
      "submitDualApproval": "Envoyer pour approbation",
      "submitApply": "Confirmer l'ajustement"
    }
  },
  "adminMgmt": {
    "page": {
      "title": "Gestion des Admins",
      "saOnlyBadge": "SA uniquement",
      "description": "Créez, modifiez les rôles, désactivez les comptes du personnel. Le bootstrap 2FA est obligatoire avant qu'un nouveau compte ne puisse se connecter.",
      "denied": "Seuls les Super Admins ont accès à cette page."
    },
    "role": {
      "all": "Tous les rôles",
      "superadmin": "Super Admin",
      "admin": "Admin",
      "supportAdmin": "Support Admin",
      "accountant": "Comptable",
      "saler": "Vendeur",
      "manager": "Manager"
    },
    "status": {
      "all": "Tous les statuts",
      "active": "Actif",
      "disabled": "Désactivé"
    },
    "mfa": {
      "enrolled": "Activée",
      "notEnrolled": "Pas encore"
    },
    "column": {
      "name": "Nom",
      "email": "Email",
      "role": "Rôle",
      "status": "Statut",
      "mfa": "MFA",
      "lastLogin": "Dernière connexion",
      "createdAt": "Créé le",
      "actions": "Actions"
    },
    "filter": {
      "label": "Filtres",
      "role": "Rôle",
      "status": "Statut",
      "search": "Rechercher par email/nom",
      "searchPlaceholder": "email@printway.work"
    },
    "action": {
      "createAdmin": "Créer un admin",
      "deactivate": "Désactiver",
      "reset2fa": "Réinitialiser 2FA",
      "enable2fa": "Activer 2FA"
    },
    "tooltip": {
      "selfDeactivate": "Vous ne pouvez pas désactiver votre propre compte",
      "needOneSa": "Au moins un Super Admin actif est requis",
      "alreadyDisabled": "Le compte est déjà désactivé",
      "deactivateAccount": "Désactiver le compte",
      "reactivateBefore2fa": "Compte désactivé — réactivez-le avant de configurer la 2FA",
      "reset2faAdmin": "Réinitialiser la 2FA de cet admin",
      "enable2faRequired": "Activer la 2FA (requise avant l'activation)",
      "superAdmin": "Super Admin"
    },
    "banner": {
      "lastSa": "Au moins un Super Admin actif est requis. Promouvez un autre Super Admin avant de désactiver ou rétrograder l'actuel.",
      "selfDemote": "Vous ne pouvez pas vous rétrograder tant que vous êtes le seul Super Admin. Promouvez un autre Super Admin d'abord."
    },
    "deactivateDialog": {
      "title": "Désactiver {{email}}",
      "description": "Le compte sera déconnecté de toutes les sessions ouvertes. Cette action est enregistrée dans le journal d'audit avec la raison ci-dessous.",
      "reasonLabel": "Raison (au moins 10 caractères)",
      "cancel": "Annuler",
      "confirm": "Désactiver",
      "submitting": "Traitement…"
    },
    "toast": {
      "deactivateSuccessTitle": "Compte désactivé",
      "deactivateSuccessDescription": "{{count}} sessions révoquées.",
      "deactivateErrorTitle": "Désactivation impossible",
      "twofaSuccessTitle": "2FA activée avec succès",
      "twofaSuccessDescription": "Le compte est prêt à se connecter."
    },
    "list": {
      "errorFallback": "Impossible de charger la liste des admins.",
      "empty": "Aucun admin ne correspond au filtre actuel."
    }
  },
  "imapParser": {
    "page": {
      "title": "Surveillance du parseur IMAP"
    },
    "tab": {
      "gateways": "Passerelles",
      "logs": "Journaux de parsing"
    },
    "gateway": {
      "listTitle": "Liste des passerelles",
      "count": "{{count}} passerelle",
      "refresh": "Actualiser",
      "refreshing": "Chargement…",
      "newGateway": "+ Nouvelle passerelle",
      "empty": "Aucune passerelle IMAP pour le moment.",
      "active": "Actif",
      "inactive": "Inactif",
      "errorCount": "{{count}} erreurs",
      "pollSuffix": "poll {{seconds}}s"
    },
    "editor": {
      "titleEdit": "Modifier : {{label}}",
      "titleCreate": "Créer une nouvelle passerelle",
      "defaultLabel": "passerelle",
      "host": "Hôte",
      "port": "Port",
      "email": "Email",
      "emailPlaceholder": "topup-bot@printway.work",
      "password": "Mot de passe",
      "passwordKeepHintExisting": "(laissez vide pour conserver l'actuel)",
      "passwordKeepHintBlank": "(laissez vide pour conserver)",
      "passwordPlaceholderEdit": "••••••••",
      "passwordPlaceholderCreate": "mot-de-passe-spécifique-app",
      "pollInterval": "Intervalle de polling (secondes ≥ {{min}})",
      "inboxFolder": "Dossier boîte de réception",
      "regexSender": "Regex — Filtre expéditeur",
      "regexTransaction": "Regex — ID de transaction",
      "regexAmount": "Regex — Montant",
      "active": "Actif",
      "save": "Enregistrer les modifications",
      "create": "Créer la passerelle",
      "saving": "Enregistrement…",
      "testConnection": "Tester la connexion",
      "testing": "Test en cours…",
      "reset": "Réinitialiser",
      "delete": "Supprimer"
    },
    "validation": {
      "required": "Obligatoire",
      "portRange": "Port 1-65535",
      "emailInvalid": "Email invalide",
      "passwordMin": "Mot de passe ≥ 8 caractères",
      "passwordMinOptional": "Mot de passe ≥ 8 caractères (ou laissez vide pour conserver l'actuel)",
      "pollRange": "L'intervalle de polling doit être ≥ {{min}}s et ≤ {{max}}s"
    },
    "testConnection": {
      "resultMessageCount": "{{count}} emails dans la boîte de réception.",
      "lastPrefix": "Dernier :"
    },
    "parseTest": {
      "title": "Test de parsing (collez un exemple d'email)",
      "samplePlaceholder": "From: noreply@vietcombank.com.vn\\nSubject: Confirmation de paiement\\nTransaction TXN12345 — montant : 1,000,000…",
      "run": "Lancer le test de parsing",
      "running": "Parsing en cours…",
      "senderMatch": "Correspondance expéditeur :",
      "senderYes": "Oui",
      "senderNo": "Non",
      "transactionId": "ID de transaction :",
      "amount": "Montant :"
    },
    "logs": {
      "gatewayId": "ID de passerelle",
      "gatewayIdPlaceholder": "ObjectId 24-hex",
      "status": "Statut",
      "statusAll": "Tous",
      "from": "Date début",
      "to": "Date fin",
      "refresh": "Actualiser",
      "refreshing": "Chargement…",
      "column": {
        "timestamp": "Horodatage",
        "gateway": "Passerelle",
        "sender": "Expéditeur",
        "amount": "Montant",
        "txnId": "ID Txn",
        "status": "Statut",
        "topupId": "ID Topup"
      },
      "empty": "Aucun journal de parsing ne correspond au filtre actuel."
    },
    "deleteDialog": {
      "title": "Supprimer la passerelle IMAP ?",
      "description": "Supprimer la passerelle {{email}} ? Le polling s'arrêtera immédiatement ; il s'agit d'une suppression douce et entièrement auditable.",
      "confirm": "Supprimer"
    },
    "toast": {
      "loadGatewaysErrorTitle": "Impossible de charger les passerelles IMAP",
      "loadGenericErrorDescription": "Impossible de charger la liste",
      "loadLogsErrorTitle": "Impossible de charger les journaux de parsing",
      "createSuccessTitle": "Passerelle IMAP créée",
      "updateSuccessTitle": "Passerelle IMAP mise à jour",
      "saveErrorTitle": "Échec de l'enregistrement",
      "saveErrorDescription": "Échec de l'enregistrement",
      "deleteSuccessTitle": "Passerelle IMAP supprimée",
      "deleteErrorTitle": "Échec de la suppression",
      "deleteErrorDescription": "Échec de la suppression",
      "needSaveTitle": "Enregistrez d'abord",
      "needSaveDescription": "Veuillez enregistrer la passerelle avant de tester la connexion.",
      "testConnectionSuccessTitle": "Test de connexion réussi",
      "testConnectionErrorTitle": "Échec du test de connexion",
      "testConnectionErrorDescription": "Impossible de se connecter",
      "sampleTooShortTitle": "Échantillon trop court",
      "sampleTooShortDescription": "L'échantillon email doit comporter ≥ {{min}} caractères.",
      "missingRegexTitle": "Patterns regex manquants",
      "missingRegexDescription": "Veuillez remplir les 3 patterns regex.",
      "parseMatchTitle": "L'échantillon correspond à l'expéditeur",
      "parseNoMatchTitle": "L'échantillon ne correspond PAS à l'expéditeur",
      "parseMatchDescription": "Txn={{txn}}, Montant={{amount}}",
      "parseNoMatchDescription": "Le regex sender_filter ne correspond pas à l'échantillon.",
      "parseErrorTitle": "Échec du test de parsing",
      "parseErrorDescription": "Impossible de parser"
    }
  },
  "security": {
    "page": {
      "title": "Paramètres système — Sécurité",
      "description": "Configurez la blacklist IP, la détection d'anomalies, le Mode Urgence et la 2FA pour les rôles admin. Chaque modification est auditée et émet un événement WS system.*.",
      "readOnlyNotice": "Vous êtes en mode lecture seule. La permission {{permission}} est requise pour modifier.",
      "loadError": "Impossible de charger les paramètres de sécurité.",
      "saveErrorFallback": "Impossible d'enregistrer les paramètres."
    },
    "form": {
      "ariaTitle": "Paramètres de politique de sécurité"
    },
    "twofa": {
      "legend": "2FA — obligatoire par rôle",
      "description": "Activez pour forcer les utilisateurs de ce rôle à activer la 2FA dans le délai de grâce. Après ce délai, la connexion est bloquée jusqu'à l'enrôlement.",
      "role": {
        "superadmin": "Super Admin",
        "admin": "Admin",
        "support": "Support",
        "accountant": "Comptable"
      },
      "graceDays": "Période de grâce (jours)"
    },
    "password": {
      "legend": "Politique de mot de passe",
      "minLength": "Longueur minimale",
      "expiryDays": "Expire après (jours)",
      "historyCount": "Historique (pas de réutilisation des N derniers)",
      "requireComplexity": "Exiger la complexité (lettres + chiffres + caractères spéciaux)"
    },
    "anomaly": {
      "legend": "Détection d'anomalies — seuils",
      "failedLoginThreshold": "Tentatives de connexion échouées",
      "failedLoginWindow": "Fenêtre temporelle (minutes)",
      "failedLoginBlockHours": "Durée de blocage (heures)",
      "bulkKycThreshold": "Seuil d'accès bulk-KYC"
    },
    "ipAutoblock": {
      "legend": "IP auto-block — seuils de blocage automatique",
      "violationCount": "Violations",
      "windowHours": "Pendant (heures)",
      "blockHours": "Durée de blocage (heures)"
    },
    "dualApproval": {
      "legend": "Double approbation — seuils",
      "refundUsd": "Remboursement (USD)",
      "creditMemoUsd": "Note de crédit (USD)",
      "bulkActionCount": "Action en masse (nombre d'enregistrements)"
    },
    "saveBar": {
      "version": "Version : {{version}}",
      "savedAt": "Enregistré à {{time}}",
      "save": "Enregistrer les modifications",
      "saving": "Enregistrement..."
    },
    "ipList": {
      "title": "IP blacklist / whitelist",
      "tabAria": "Type de liste IP",
      "blacklist": "Blacklist",
      "whitelist": "Whitelist",
      "addLabel": "Ajouter à {{type}}",
      "adding": "Ajout...",
      "cidrLabel": "IP / CIDR",
      "cidrPlaceholder": "ex : 192.168.1.0/24",
      "reasonLabel": "Raison",
      "requiredError": "Veuillez saisir l'IP/CIDR et la raison.",
      "addErrorFallback": "Impossible d'ajouter l'IP.",
      "column": {
        "cidr": "IP / CIDR",
        "reason": "Raison",
        "addedBy": "Ajouté par",
        "addedAt": "Ajouté le",
        "violations": "Violations",
        "actions": "Actions"
      },
      "loading": "Chargement...",
      "emptyTab": "Aucune IP dans {{type}} pour le moment.",
      "remove": "Supprimer",
      "removeConfirm": "Supprimer {{ip}} de {{type}} ?"
    },
    "blockedIps": {
      "title": "Actuellement bloqués automatiquement ({{count}})",
      "loading": "Chargement...",
      "empty": "Aucune IP n'est actuellement bloquée automatiquement.",
      "column": {
        "cidr": "IP / CIDR",
        "reason": "Raison",
        "blockedAt": "Bloqué le",
        "expiresAt": "Expire",
        "violations": "Violations",
        "actions": "Actions"
      },
      "unblock": "Débloquer",
      "unblockConfirm": "Débloquer {{ip}} ?"
    }
  },
  "products": {
    "templateCanvas": {
      "bandLabel": "Éditeur canvas",
      "noArea": "Aucune zone dans cette règle de validation — ajoutez-en une pour modifier les régions.",
      "footerCancel": "Annuler",
      "footerSave": "Enregistrer",
      "footerSaving": "Enregistrement…",
      "cancelConfirmTitle": "Abandonner les modifications non enregistrées ?",
      "cancelConfirmBody": "Vous avez des modifications non enregistrées. Quitter cette page les perdra.",
      "cancelConfirmYes": "Abandonner",
      "cancelConfirmNo": "Continuer l’édition"
    },
    "wizard": {
      "step": {
        "logistics": {
          "title": "Logistique",
          "description": "Déclarez le poids, les dimensions et les frais d’expédition par service pour chaque SKU",
          "column": {
            "weight": "Poids",
            "length": "Longueur",
            "width": "Largeur",
            "height": "Hauteur"
          },
          "unit": {
            "gram": "g",
            "kilogram": "kg",
            "oz": "oz",
            "lb": "lb",
            "centimeter": "cm",
            "inch": "in",
            "millimeter": "mm"
          },
          "applySelected": {
            "weight": "Appliquer le poids aux lignes sélectionnées",
            "dimensions": "Appliquer les dimensions aux lignes sélectionnées"
          },
          "bulkEditWeight": "Modifier le poids en lot",
          "bulkEditDimensions": "Modifier les dimensions en lot",
          "bulkEditDimensionsUnit": "Unité",
          "bulkEditApply": "Appliquer",
          "bulkEditCancel": "Annuler",
          "bulkEditAffects": "S’applique à {{count}} lignes sélectionnées",
          "clearSelected": "Effacer les valeurs des lignes sélectionnées",
          "unitConvertHint": "Unités converties côté serveur en grammes + cm"
        }
      }
    },
    "productionType": {
      "printing": "Impression",
      "embroidery": "Broderie",
      "cutting": "Découpe",
      "blank": "Blank"
    },
    "techniques": {
      "section": {
        "cutting": {
          "title": "Méthodes de découpe",
          "description": "Tarification de découpe par zone reportée à MVP-C"
        },
        "blank": {
          "title": "Produits blank",
          "description": "Produits unis sans zone d’impression / broderie"
        }
      }
    },
    "validation": {
      "logistics": {
        "weightRequired": "Poids requis pour activer le blueprint",
        "dimensionRequired": "Dimensions (L/l/H) requises pour activer",
        "incompleteForActive": "SKU sans logistique : {{skus}}"
      }
    }
  },
  "chrome": {
    "profileDropdown": {
      "account": "Mon compte",
      "preferences": "Préférences (Thème / Langue / Fuseau)",
      "sessions": "Sessions",
      "shortcuts": "Raccourcis clavier",
      "logout": "Déconnexion",
      "shortcutCommandPalette": "Ouvrir la palette de commandes",
      "shortcutNotifications": "Ouvrir les notifications",
      "shortcutsComingSoon": "La liste complète sera ajoutée dans une prochaine vague.",
      "logoutConfirm": "Voulez-vous vraiment vous déconnecter du compte admin ?",
      "cancel": "Annuler",
      "logoutConfirmAction": "Se déconnecter",
      "toggleSidebar": "Afficher/masquer la barre latérale",
      "close": "Fermer"
    },
    "notificationBell": {
      "filters": {
        "all": "Tout",
        "orders": "Commandes",
        "products": "Produits",
        "stores": "Boutiques",
        "system": "Système"
      },
      "timeAgo": {
        "justNow": "à l'instant",
        "minutes_one": "il y a {{count}} minute",
        "minutes_other": "il y a {{count}} minutes",
        "hours_one": "il y a {{count}} heure",
        "hours_other": "il y a {{count}} heures",
        "days_one": "il y a {{count}} jour",
        "days_other": "il y a {{count}} jours"
      },
      "title": "Notifications",
      "markAllRead": "Tout marquer comme lu",
      "empty": "Aucune notification pour le moment.",
      "viewAll": "Voir toutes les notifications",
      "viewDetail": "Voir le détail →",
      "markReadError": "Impossible de marquer comme lu. Veuillez réessayer.",
      "markAllReadError": "Impossible de tout marquer comme lu. Veuillez réessayer.",
      "reloadPrompt": "Une nouvelle version est disponible — veuillez actualiser votre navigateur.",
      "forbidden": {
        "title": "Notifications indisponibles",
        "body": "Vous n'avez pas accès à un fil de notifications pour le moment.",
        "retry": "Réessayer"
      }
    },
    "impersonationBanner": {
      "roles": {
        "merchantOwner": "Propriétaire marchand",
        "merchantStaff": "Personnel marchand",
        "vendorOwner": "Propriétaire fournisseur",
        "vendorStaff": "Personnel fournisseur"
      },
      "viewingAs": "Vu en tant que {{name}} ({{role}}).",
      "stopAria": "Quitter le mode d'emprunt d'identité",
      "readonlyMode": "Mode lecture seule",
      "writeMode": "Mode écriture (5 min)",
      "stop": "Quitter"
    },
    "languageSelector": {
      "selectLanguage": "Choisir la langue"
    },
    "banners": {
      "realtime": {
        "connected": "Connexion temps réel rétablie",
        "reconnecting": "Reconnexion au temps réel…",
        "attempt": "Tentative n°{{attempt}}",
        "retryIn": "Nouvelle tentative dans {{sec}} s",
        "retryNow": "Réessayer",
        "disconnected": "Connexion temps réel perdue — les données peuvent ne pas se mettre à jour immédiatement",
        "disconnectedHint": "Vérifiez votre réseau ou cliquez sur « Réessayer » pour vous reconnecter manuellement."
      },
      "announcement": {
        "priority": {
          "critical": "Critique",
          "high": "Important",
          "medium": "Avis",
          "low": "Actualités"
        },
        "positionAria": "Bannière {{current}} / {{total}}",
        "prevAria": "Bannière précédente",
        "nextAria": "Bannière suivante",
        "dismissAria": "Masquer cette annonce"
      },
      "dualApproval": {
        "pending": "Action nécessitant une double approbation"
      }
    },
    "timezoneSelector": {
      "selectTimezone": "Choisir le fuseau horaire",
      "zone": {
        "vietnam": "Viêt Nam",
        "usEastern": "États-Unis (Est)",
        "usPacific": "États-Unis (Pacifique)",
        "unitedKingdom": "Royaume-Uni",
        "japan": "Japon",
        "germany": "Allemagne",
        "australia": "Australie",
        "china": "Chine"
      },
      "searchPlaceholder": "Rechercher un fuseau…",
      "noMatch": "Aucun fuseau correspondant",
      "searchHint": "Recherchez pour choisir un autre fuseau"
    }
  },
  "ui": {
    "blueprintMultiSelect": {
      "selected_one": "{{count}} sélectionné",
      "selected_other": "{{count}} sélectionnés",
      "rangeHint": "(besoin de {{min}}-{{max}})",
      "minHint": "(minimum {{min}})",
      "maxHint": "(maximum {{max}})",
      "atMax": "Maximum {{max}} atteint",
      "noMatch": "Aucun blueprint correspondant.",
      "change": "Modifier",
      "resolving": "Chargement…"
    },
    "merchantMultiSelect": {
      "rangeHint": "(besoin de {{min}}–{{max}})",
      "searchPlaceholder": "Rechercher des marchands par nom / e-mail…",
      "loading": "Chargement…",
      "noResults": "Aucun résultat",
      "removeAria": "Retirer {{name}}"
    },
    "pricingTierSelect": {
      "placeholder": "Choisir le palier tarifaire",
      "loadError": "Échec du chargement des paliers tarifaires : {{error}}",
      "empty": "Aucun palier tarifaire pour le moment."
    },
    "impersonationBanner": {
      "viewingAs": "Vu en tant que {{name}} ({{role}}).",
      "stopAria": "Quitter le mode d'emprunt d'identité",
      "stop": "Quitter",
      "readonlyMode": "Mode lecture seule",
      "writeMode": "Mode écriture (5 min)"
    },
    "backLink": {
      "back": "Retour"
    }
  },
  "modals": {
    "createApprovalRequest": {
      "submitError": "Impossible de soumettre la demande — veuillez réessayer",
      "reasonPlaceholder": "Décrivez le motif en détail pour que le Super Admin puisse approuver rapidement (ex. : le ticket de support client TK-1234 demande un remboursement pour la commande de 750 $)",
      "submitting": "Soumission…",
      "description": "La demande devra être approuvée par un autre Super Admin/Admin dans un délai d'une heure. Veuillez fournir une raison claire afin que le second approbateur puisse décider rapidement.",
      "viewPayload": "Voir le payload à soumettre",
      "reasonLabel": "Raison (minimum 10 caractères, maximum 1000)",
      "cancel": "Annuler"
    },
    "sessionExpired": {
      "title": "Votre session a expiré",
      "body": "Pour des raisons de sécurité, votre session a pris fin. Veuillez vous reconnecter pour poursuivre votre travail.",
      "returnHint": "Après la connexion, le système reviendra à la page :",
      "loginAgain": "Se reconnecter"
    },
    "bulkActionConfirm": {
      "reasonPlaceholder": "Décrivez le motif de cette action groupée — il sera consigné dans le journal d'audit.",
      "charsNeeded_one": "{{count}} caractère supplémentaire requis",
      "charsNeeded_other": "{{count}} caractères supplémentaires requis",
      "processing": "Traitement…",
      "actionItems_one": "{{action}} {{count}} élément",
      "actionItems_other": "{{action}} {{count}} éléments",
      "title_one": "{{action}} — {{count}} élément",
      "title_other": "{{action}} — {{count}} éléments",
      "confirmPrefix": "Veuillez confirmer l'action ",
      "confirmSuffix": ". Les actions groupées ne peuvent pas être entièrement annulées — vérifiez la portée et la raison avant de continuer.",
      "scopeLegend": "Portée",
      "scopeSelected_one": "Seulement {{count}} élément sélectionné sur la page actuelle",
      "scopeSelected_other": "Seulement {{count}} éléments sélectionnés sur la page actuelle",
      "scopeMatching_one": "Tous les {{count}} élément correspondant au filtre actuel",
      "scopeMatching_other": "Tous les {{count}} éléments correspondant au filtre actuel",
      "reasonLabel": "Raison (audit — obligatoire, {{reasonMinLength}}–{{reasonMaxLength}} caractères)",
      "approvalPrefix": "Cette action dépasse le seuil ({{threshold}} éléments) — nécessite",
      "approvalSuffix": "approbation(s) supplémentaire(s) d'un autre admin avant l'exécution.",
      "cancel": "Annuler"
    },
    "optimisticLock": {
      "yours": "Les vôtres",
      "serverNewer": "Serveur (plus récent)",
      "mergeProposed": "Fusion proposée",
      "saving": "Enregistrement…",
      "saveMerge": "Enregistrer la version fusionnée",
      "conflictTitle": "Modification conflictuelle détectée",
      "conflictBody": "Un autre admin a modifié cet enregistrement pendant que vous l'éditiez. Comparez vos données actuelles avec la dernière version sur le serveur et choisissez comment procéder.",
      "cancel": "Annuler",
      "forceOverwrite": "Écraser (Super Admin)"
    },
    "exportFormatPicker": {
      "processing": "Traitement…",
      "queueEmail": "Mettre en file + m'envoyer par e-mail",
      "downloadNow": "Télécharger maintenant",
      "title": "Exporter les données — {{tableKey}}",
      "description": "Chaque export est filigrané avec le nom de l'admin, l'horodatage et l'ID d'export à des fins d'audit. Les exports volumineux sont mis en file d'attente et le lien est envoyé par e-mail.",
      "formatLegend": "Format",
      "columnsLegend": "Colonnes exportées ({{selected}}/{{available}})",
      "estimatedSizeLabel": "Taille estimée : ",
      "rowsCount_one": "({{count}} ligne)",
      "rowsCount_other": "({{count}} lignes)",
      "backgroundNotice": "Le fichier dépasse {{size}} — il sera traité en arrière-plan et le lien de téléchargement sera envoyé à votre e-mail.",
      "watermarkTitle": "Avis de filigrane :",
      "watermarkBody": "L'export inscrira le nom “{{adminName}}”, l'horodatage et l'ID d'export dans le contenu du fichier à des fins d'audit. Ne redistribuez pas le fichier en dehors du périmètre autorisé.",
      "cancel": "Annuler"
    }
  },
  "notifications": {
    "center": {
      "title": "Notifications",
      "loading": "Chargement…",
      "refresh": "Actualiser",
      "empty": "Aucune notification pour le moment.",
      "loadError": "Échec du chargement des notifications : {{error}}",
      "filters": {
        "all": "Toutes",
        "auth": "Auth",
        "vendor": "Vendor",
        "system": "System"
      }
    },
    "item": {
      "justNow": "à l'instant",
      "minutesAgo_one": "il y a {{count}} minute",
      "minutesAgo_other": "il y a {{count}} minutes",
      "hoursAgo_one": "il y a {{count}} heure",
      "hoursAgo_other": "il y a {{count}} heures",
      "daysAgo_one": "il y a {{count}} jour",
      "daysAgo_other": "il y a {{count}} jours"
    }
  },
  "roleCatalog": {
    "descriptions": {
      "superadmin": "Accès complet au système (joker fourre-tout *:*).",
      "admin": "Administration de la plateforme — jokers de module + facturation granulaire.",
      "support": "Équipe support (activée à partir de la Phase 9).",
      "saler": "Équipe commerciale (activée à partir de la Phase 10).",
      "manager": "Gestion des marchands (activée à partir de la Phase 10).",
      "accountant": "Comptabilité — 12 autorisations financières (amendements).",
      "affiliate": "Affilié (activé à partir de la Phase 10)."
    },
    "moduleLabels": {
      "auth": "Authentification (Auth)",
      "user": "Utilisateurs (Users)",
      "team": "Équipe (Team)",
      "permission": "Autorisations (Permissions)",
      "storage": "Stockage (Storage)",
      "survey": "Sondage (Survey)",
      "notification": "Notifications",
      "emergency": "Urgence (Emergency)",
      "billing": "Facturation (Billing)",
      "invoice": "Factures (Invoices)",
      "legal_entity": "Entité juridique (Legal entity)"
    }
  },
  "adminMgmtApi": {
    "validation": {
      "emailInvalid": "E-mail invalide",
      "emailDomain": "L’e-mail doit se terminer par @printway.work",
      "nameMin": "Le nom doit comporter au moins 2 caractères",
      "nameMax": "Le nom doit comporter au plus 100 caractères",
      "emailDomainNotAllowed": "L'e-mail doit utiliser un domaine de l'entreprise : {{domains}}"
    }
  },
  "apiMessages": {
    "adminUsers": {
      "validation": {
        "emailInvalid": "E-mail invalide",
        "emailMax": "L'e-mail ne doit pas dépasser 320 caractères",
        "displayNameMin": "Le nom affiché doit comporter au moins 2 caractères",
        "displayNameMax": "Le nom affiché ne doit pas dépasser 120 caractères"
      }
    },
    "announcements": {
      "scheduleStartRequired": "schedule_start est obligatoire",
      "scheduleDatesInvalid": "schedule_start / schedule_end n’est pas une date valide",
      "scheduleEndAfterStart": "schedule_end doit être postérieur à schedule_start"
    },
    "featureFlags": {
      "productionToggleWarning": "Ce paramètre affecte la production — un second Super Admin doit l’approuver."
    },
    "audit": {
      "networkFallback": "Le réseau n’a pas répondu — veuillez réessayer."
    }
  },
  "dashboard": {
    "merchantCredit": "Crédit marchand",
    "merchantCreditSubtitle": "Historique, attribution, modification et révocation du crédit pour chaque marchand.",
    "quickActions": "Actions rapides",
    "comingSoon": "Bientôt disponible"
  },
  "home": {
    "manageUsers": {
      "title": "Gérer les utilisateurs",
      "description": "Consulter, suspendre ou incarner les membres de la plateforme. Inclut les admins, marchands et fournisseurs."
    },
    "pendingVendors": {
      "title": "Fournisseurs en attente",
      "description": "Examiner les candidatures, approuver ou rejeter les inscriptions fournisseurs avec notes obligatoires."
    },
    "accountSettings": {
      "title": "Paramètres du compte",
      "description": "Mettre à jour votre profil, mot de passe, inscription 2FA et préférences."
    },
    "merchants": {
      "title": "Marchands",
      "description": "Gérer les boutiques marchandes, la facturation et l’incarnation."
    },
    "orders": {
      "title": "Commandes",
      "description": "Suivi et intervention sur les commandes multi-portails."
    },
    "auditLog": {
      "title": "Visionneuse du journal d’audit",
      "description": "Parcourir les événements d’audit métier et sécurité."
    }
  },
  "shellChrome": {
    "breadcrumbAria": "Fil d’Ariane",
    "sidebarAria": "Barre latérale",
    "topBarAria": "Barre supérieure",
    "profileMenuAria": "Menu utilisateur",
    "notificationsAria": "Notifications",
    "markAsReadAria": "Marquer comme lu",
    "dismissAria": "Ignorer",
    "backToTop": "Retour en haut",
    "bulkActionBarAria": "Barre d’actions groupées",
    "editorToolbarAria": "Barre d’outils de l’éditeur"
  },
  "cms": {
    "i18nTabs": {
      "languageAria": "Langue",
      "complete": "Complet",
      "partial": "Partiel",
      "empty": "Vide"
    },
    "mediaPicker": {
      "insertImage": "Insérer une image",
      "dropImageAria": "Déposez l’image ici",
      "chooseFileAria": "Choisir un fichier image",
      "altPlaceholder": "Décrivez l’image pour les lecteurs d’écran"
    },
    "editorLayout": {
      "editorAria": "Éditeur",
      "sidebarAria": "Barre latérale"
    },
    "rte": {
      "toolbarAria": "Barre d’outils de l’éditeur de texte enrichi",
      "bold": "Gras",
      "italic": "Italique",
      "underline": "Souligné",
      "strikethrough": "Barré",
      "h1": "Titre 1",
      "h2": "Titre 2",
      "h3": "Titre 3",
      "bulletList": "Liste à puces",
      "orderedList": "Liste numérotée",
      "blockquote": "Citation",
      "codeBlock": "Bloc de code",
      "link": "Lien",
      "image": "Image",
      "embedVideo": "Intégrer une vidéo (YouTube/Vimeo)",
      "insertTable": "Insérer un tableau",
      "horizontalDivider": "Séparateur horizontal",
      "undo": "Annuler",
      "redo": "Rétablir"
    }
  },
  "datatable": {
    "rows": "Lignes",
    "rowsPerPage": "Lignes par page",
    "exportFormatAria": "Format d’export",
    "paginationAria": "Pagination",
    "previousPage": "Page précédente",
    "nextPage": "Page suivante",
    "toggleColumnsAria": "Afficher/masquer les colonnes",
    "selectAllRowsAria": "Sélectionner toutes les lignes de cette page",
    "savedViewsAria": "Vues enregistrées",
    "deleteSavedViewConfirm": "Supprimer la vue enregistrée « {{name}} » ?",
    "defaultBadge": "Par défaut",
    "dragToReorderAria": "Glisser pour réorganiser la colonne",
    "expand": "Développer",
    "filter": {
      "anyOption": "Tous",
      "yesOption": "Oui",
      "noOption": "Non",
      "hideFilters": "Masquer les filtres",
      "moreFilters": "Plus de filtres ({{count}})",
      "clearFilters": "Effacer ({{count}})"
    },
    "firstPage": "Première page",
    "lastPage": "Dernière page",
    "showingRange": "Affichage de {{from}}-{{to}} sur {{total}}",
    "pageOfCount": "Page {{page}} sur {{total}}",
    "pageAria": "Page {{page}}"
  },
  "cmdk": {
    "paletteLabel": "Palette de commandes",
    "searchPlaceholder": "Rechercher marchands, fournisseurs, commandes, boutiques, pages…",
    "kbdHintsAria": "Raccourcis clavier de la palette de commandes"
  },
  "suspendDialog": {
    "suspendReasonPlaceholder": "ex. Activité frauduleuse suspectée — enquête en cours",
    "reactivateReasonPlaceholder": "ex. Identité vérifiée — faux positif"
  },
  "versionBanner": {
    "updateAvailable": "Une nouvelle version est disponible{{versionSuffix}} — veuillez actualiser votre navigateur pour utiliser la dernière version.",
    "autoRefreshIn": "Actualisation automatique dans",
    "refreshNow": "Actualiser maintenant"
  },
  "_vgBinding": "vg-binding: P8.1.1.D-15 — libellé datatable.defaultBadge pour le badge Par défaut de ColumnToggle, ajouté pour en/vi/fr [task-11]"
}
